import 'babel-polyfill'
import React from 'react'
import { render } from 'react-dom'
import { Provider } from 'react-redux'
import { Router, Route, IndexRoute, hashHistory } from 'react-router'
import { syncHistoryWithStore, routerReducer } from 'react-router-redux'
import { createStore, combineReducers } from 'redux'
import { App, Home, Brand, Core, Components, Layouts, Themes, GettingStarted } from './components'
import * as reducers from './reducers'
import * as actions from './actions'

const reducer = combineReducers({
  ...reducers,
  routing: routerReducer
})
const store = createStore(
  reducer
)

store.dispatch(actions.toggleStaticVersion(true))

function scrollToAnchor() {
  const hashParts = window.decodeURIComponent(window.location.hash).split('#');
  if(hashParts && hashParts.length >= 2 && hashParts[1] !== '') {
    const subHashParts = hashParts[1].split('/');
    if (subHashParts && subHashParts.length === 3 && subHashParts[2] !== '') {
      const subHash = (subHashParts[2].indexOf('?') > -1) ? subHashParts[2].substr(0, subHashParts[2].indexOf('?')) : subHashParts[2];
      if (subHash !== '') {
        if (document.querySelector('#' + subHash)) {
          document.querySelector('#' + subHash).scrollIntoView();
        }
      }
    }
  }
}

render(
  <Provider store={store}>
    <Router history={hashHistory}>
      <Route path="/" component={App}>
        <IndexRoute component={Home}/>
        <Route path="home" component={Home}/>
        <Route path="home/:section" component={Home} onEnter={scrollToAnchor}/>
        <Route path="brand" component={Brand}/>
        <Route path="brand/:section" component={Brand} onEnter={scrollToAnchor}/>
        <Route path="core" component={Core}/>
        <Route path="core/:section" component={Core} onEnter={scrollToAnchor}/>
        <Route path="components" component={Components}/>
        <Route path="components/:section" component={Components} onEnter={scrollToAnchor}/>
        <Route path="layouts" component={Layouts}/>
        <Route path="layouts/:section" component={Layouts} onEnter={scrollToAnchor}/>
        <Route path="themes" component={Themes}/>
        <Route path="themes/:section" component={Themes} onEnter={scrollToAnchor}/>
        <Route path="getting-started" component={GettingStarted}/>
        <Route path="getting-started/:section" component={GettingStarted} onEnter={scrollToAnchor}/>
      </Route>
    </Router>
  </Provider>,
  document.getElementById('root')
)



// WEBPACK FOOTER //
// ./styleguide/index.static.js